import { T } from '@tribeplatform/react-components/i18n'

import { HomepageSettings } from '../HomepageSettings/HomepageSettings.js'

export function CommunityHomepageSettingsRouter() {
  return <HomepageSettings />
}

export function CommunityHomepageSettingsBreadCrumb() {
  return <T id="Settings.Homepage" defaultMessage="Homepage" />
}
